export default __webpack_public_path__ + "static/media/creditcard.fa27881e.svg";